module.exports = __webpack_public_path__ + "static/media/animmersion-logo-charcoal.8b337248.svg";